<script>
import { opensUebungCreateModalMixin } from "@/uebungen-library/mixins/opensUebungCreateModal.mixin.js";
export default {
  name: "uebungen-library-category-uebung-classic-create",
  mixins: [opensUebungCreateModalMixin],
}
</script>

<template>
<div>
  <div>
    <button @click="this.$emit('uebungen-library__set-active-step', 'create-uebung')" class="left-0 pl-5 w-24 h-24 text-5xl bg-white hover:bg-primary-700 hover:text-white text-primary-700 p-4 shadow-lg ">
      <i class="fas fa-caret-left"></i>
    </button>
    <div>
      <h1>UebungenLibrary__CategoryUebungClassicCreate</h1>
      <button v-for="(uebung, alias) in this.$UebungenRegistry.registered_uebungen" @click="this.openUebungCreateModal({
        title: `${uebung.components.create.title}`,
        componentPath: uebung.components.create.path,
        moduleName: uebung.module.name,
      })" class="m-5 shadow p-3 bg-white hover:bg-primary-200">
        <div class="text-2xl"><i class="fas fa-plus-square mr-2"></i>{{uebung.title}}</div>
        <div class="flex mt-2">{{uebung.description}}</div>
      </button>
    </div>
  </div>
</div>
</template>

<style scoped>

</style>